import BaseCommand from "@/models/api/commands/BaseCommand";

export interface OrderItemChangeAttributeParams {
  AttributePrototypeId: number; // 54;
  DataType: number; // 6;
  IsPrintable: boolean; // false;
  Label: string; // "Przewoźnik";
  Ordinal: number; // 7;
  Value: string; // "Koleje Dolnośląskie";
  TmpId: string | null;
}

export class OrderItemChangeCommandParams {
  Currency = "PLN";
  ExchangeDate = "2021-03-15"; //TODO
  ExchangeRate = 1; // 1;
  Gross = 0; // "1.00";
  GrossInCurrency = 0; // "1.00";
  Id: string | null = "00000000-0000-0000-0000-000000000000"; // "ac520cf3-d271-4f9d-b4f9-6cd941370048";
  ImportedFromDocumentId = null;
  Modifier = 0;
  Name: string;
  NetPrice = 0; // "0.93";
  NetPriceInCurrency = 0; // "0.93";
  NetValue = 0; // "0.93";
  NetValueInCurrency = 0;
  OrderItemAttributes: Array<OrderItemChangeAttributeParams> = [];
  OwnerId = -1;
  PurchaseNetPrice = 0; // "1.00";
  PurchaseNetPriceCurrency = "PLN";
  PurchaseNetPriceExchangeDate = "";
  PurchaseNetPriceExchangeRate = 1;
  PurchaseNetPriceInCurrency = 0;
  Quantity = 1; // "1.00";
  ServiceTypeId: number | null; // 370;
  ServiceTypeCode: string | null = null; // Hotel;
  Unit = "szt.";
  VAT: string; // "8";
  VATAmount = 0;
  VATAmountInCurrency = 0;
  constructor(serviceTypeId = null, serviceName = "", vat = "") {
    this.ServiceTypeId = serviceTypeId;
    this.Name = serviceName;
    this.VAT = vat;
  }
}

export class OrderItemChangeCommand extends BaseCommand {
  CommandName = "OrderItemChange";
  Command: OrderItemChangeCommandParams;
  constructor(sessionId: string, operationId: string, params: OrderItemChangeCommandParams) {
    super(sessionId, operationId);
    this.Command = params;
  }
}
